const _excluded = ["onChange", "thousandSeparator", "decimalSeparator"],
  _excluded2 = ["onlyPositiveNumbers", "min", "max"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
export function FormattedNumberInput(_ref) {
  let {
      onChange,
      thousandSeparator = ',',
      decimalSeparator = '.'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isFocused, setIsFocused] = useState(false);

  // Default decimalScale to 2 if not provided
  props.decimalScale = !('decimalScale' in props) ? 2 : props.decimalScale;
  // Always pass decimalSeparator so it never conflicts with thousandSeparator defaults
  // (e.g. DE thousandSeparator="." vs NumericFormat's default decimalSeparator ".")
  props.decimalSeparator = decimalSeparator;

  // If the input is focused, show the raw value, otherwise default to 0 if the value is undefined or null
  const value = isFocused ? props.value : Number.parseFloat(props.value || 0).toFixed(props.decimalScale);
  const {
      onlyPositiveNumbers,
      min,
      max
    } = props,
    restOfProps = _objectWithoutProperties(props, _excluded2);
  const isAllowed = values => {
    const {
      floatValue
    } = values;

    // Allow empty/undefined values
    if (floatValue === undefined || floatValue === null) return true;

    // Check min constraint if provided
    if (min !== undefined && floatValue < min) return false;

    // Check max constraint if provided
    if (max !== undefined && floatValue > max) return false;

    // Check onlyPositiveNumbers if provided (and no min/max specified)
    if (onlyPositiveNumbers && min === undefined && max === undefined) {
      return floatValue >= 0;
    }
    return true;
  };
  const onNumericInputChange = (obj, sourceInfo) => {
    if (obj.value === '') {
      obj.value = 0;
    }
    typeof onChange === 'function' && onChange({
      target: {
        name: props.name,
        value: obj.value
      },
      sourceInfo
    });
  };
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({}, restOfProps, {
    valueIsNumericString: true,
    fixedDecimalScale: true,
    value: value,
    onValueChange: onNumericInputChange,
    customInput: Form.Control,
    thousandSeparator: thousandSeparator,
    isAllowed: isAllowed,
    onFocus: () => {
      setIsFocused(true);
      props.onFocus && props.onFocus();
    },
    onBlur: () => {
      setIsFocused(false);
      props.onBlur && props.onBlur();
    }
  }));
}